import thunk from 'redux-thunk'
import logger from 'redux-logger'
import { configureStore } from '@reduxjs/toolkit'
import tenantReducer from '../features/ami-meter-data-collection/redux/tenantSlice'
import languageReducer from './language'
import kpiDailyReducer from '../features/ami-meter-data-collection/redux/kpiDailySlice'
import deviceInfoReducer from '../features/upload-file/redux/deviceInfoSlice'
import assetByIdReducer from '../features/device-details/redux/assetByIdSlice'
import assetIdReducer from '../features/device-details/redux/assetIdSlice'
import templateDetailsReducer from '../features/configuration-upload-status/redux/selectedTemplateDetailsSlice'
import assetPHistoryReducer from '../features/device-provisioning/redux/assetProvisioingHistoryInfoSlice'
import deviceListSlice from '../features/ami-meter-data-collection/redux/deviceListSlice'
import deviceDetailReducer from '../features/device-provisioning/redux/ShowAssetDetailsSlice'
import channelDataDeviceDetailsReducer from '../features/device-details/redux/channelDataSlice'
import deviceDetailsListReducer from '../features/device-details/redux/deviceListSlice'
import deviceDataReducer from '../features/device-provisioning/redux/ProvisioningHistorySummaryDetailsInfoSlice'
import registerReadingsReducer from '../features/device-details/redux/registerReadingsSlice'
import exportAssetProvisioningDetailsReducer from '../features/device-provisioning/redux/exportAssetProvisioningDetailsSlice'
import exportProvisioningHistoryByIdReducer from '../features/device-provisioning/redux/exportProvisioningHistoryByIdSlice'
import exportProvisioningHistoryReducer from '../features/device-provisioning/redux/exportProvisioningHistorySlice'
import alarmByIdReducer from '../features/device-details/redux/alarmsByIdSlice'
import allAlarmsReducer from '../features/ami-meter-data-collection/redux/allAlarmsSlice'
import totalIssueCountReducer from '../features/ami-meter-data-collection/redux/activeIssuesCountSlice'
import addFirmwareInfoReducer from '../features/firmware/redux/addFirmwareInfoSlice'
import topIssuesReducer from '../features/ami-meter-data-collection/redux/topIssuesSlice'
import signalDataReducer from '../features/device-details/redux/cellularSignalSlice'
import provisioningHistoryDetailsFilterDeviceTypeReducer from '../features/device-provisioning/redux/provisioningHistoryDetailsFilterDeviceTypeSlice'
import provisioningHistoryDetailsFilterStateReducer from '../features/device-provisioning/redux/provisioningHistoryDetailsFilterStateSlice'
import provisioningHistoryFilterStatusReducer from '../features/device-provisioning/redux/provisioningHistoryFilterStatusSlice'
import provisioningHistoryFilterUploadedUsersReducer from '../features/device-provisioning/redux/provisioningHistoryFilterUploadedUsersSlice'
import parameterListReducer from '../features/asset-configuration/redux/parameterListSlice'
import channelDataReducer from '../features/device-details/redux/channelDropdownSlice'
import firmawareListReducer from '../features/firmware/redux/firmwareListInfoSlice'
import firmwareTypeReducer from '../features/firmware/redux/getFirmwareTypeDataInfoSlice'
import getFirmwareFilterAssetTypeReducer from '../features/firmware/redux/getFirmwareFilterAssetTypeSlice'
import getFirmwareFilterFirmwareTypeReducer from '../features/firmware/redux/getFirmwareFilterFirmwareTypeSlice'
import getFirmwareFilterVersionReducer from '../features/firmware/redux/getFirmwareFilterVersionSlice'
import exportFirmwareListReducer from '../features/firmware/redux/exportFirmwareListSlice'
import deleteFirmwareReducer from '../features/firmware/redux/deleteFirmwareSlice'
import configurationListReducer from '../features/asset-configuration/redux/configurationListSlice'
import configurationDetailsForStatusReducer from '../features/configuration-upload-status/redux/configurationDetailsSlice'
import associateAssetsReducer from '../features/asset-configuration/redux/associateAssetsSlice'
import assetTypesReducer from '../features/asset-configuration/redux/assetTypeSlice'
import createConfigurationReducer from '../features/asset-configuration/redux/createConfigurationSlice'
import assetListByAssetTypeReducer from '../features/asset-configuration/redux/unAssignedAssetsListSlice'
import disassociateAssetsReducer from '../features/asset-configuration/redux/disassociateAssetsSlice'
import configurationsForStatusReducer from '../features/configuration-upload-status/redux/configurationListForStatusSlice'
import configurationDetailsReducer from '../features/asset-configuration/redux/configDetailsSlice'
import templateIdReducer from '../features/asset-configuration/redux/templateIdSlice'
import assignedAssetListReducer from '../features/asset-configuration/redux/assignedAssetListSlice'
import thirtyDayReducer from '../features/ami-meter-data-collection/redux/thirtyDaySlice'
import grandParentBreadcrumbReducer from '../features/dashboard/redux/grandParentBreadcrumbSlice'
import allConfigDataReducer from '../features/data-publisher/redux/allConfigSlice'
import allStatusFilesReducer from '../features/data-publisher/redux/fileStatusSlice'
import createReducer from '../features/data-publisher/redux/addNewConfigSlice'
import operationPermissionsReducer from '../features/dashboard/redux/operationPermissionSlice'
import kpiTypeReducer from '../features/ami-meter-data-collection/redux/changeKpiType'
import hamburgerStateReducer from '../features/dashboard/redux/hamburgerSlice'
import ipConfigReducer from '../features/device-details/redux/ipConfigSlice'

const store: any = configureStore({
  reducer: {
    tenant: tenantReducer,
    language: languageReducer,
    kpiDailyData: kpiDailyReducer,
    deviceInfo: deviceInfoReducer,
    assetById: assetByIdReducer,
    assetId: assetIdReducer,
    deviceList: deviceListSlice,
    deviceDetail: deviceDetailReducer,
    channelDataDeviceDetail: channelDataDeviceDetailsReducer,
    deviceDetailsList: deviceDetailsListReducer,
    assetProvisioningHistoryData: assetPHistoryReducer,
    deviceData: deviceDataReducer,
    registerReadingsData: registerReadingsReducer,
    exportAssetProvisioningDetails: exportAssetProvisioningDetailsReducer,
    exportProvisioningHistoryById: exportProvisioningHistoryByIdReducer,
    exportProvisioningHistory: exportProvisioningHistoryReducer,
    alarmsById: alarmByIdReducer,
    allActiveIssues: allAlarmsReducer,
    totalIssuesCount: totalIssueCountReducer,
    addFirmwareInfoSlice: addFirmwareInfoReducer,
    topIssues: topIssuesReducer,
    signalData: signalDataReducer,
    provisioningHistoryDetailsFilterDeviceType: provisioningHistoryDetailsFilterDeviceTypeReducer,
    provisioningHistoryDetailsStateFilter: provisioningHistoryDetailsFilterStateReducer,
    provisioningHistoryFilterStatus: provisioningHistoryFilterStatusReducer,
    provisioningHistoryFilterUploadedUsers: provisioningHistoryFilterUploadedUsersReducer,
    parameterList: parameterListReducer,
    channelDropdownData: channelDataReducer,
    firmwareListData: firmawareListReducer,
    firmwareTypeData: firmwareTypeReducer,
    firmwareFilterAssetType: getFirmwareFilterAssetTypeReducer,
    firmwareFilterFirmwareType: getFirmwareFilterFirmwareTypeReducer,
    firmwareFilterVersion: getFirmwareFilterVersionReducer,
    exportFirmwareList: exportFirmwareListReducer,
    deleteFirmware: deleteFirmwareReducer,
    configurationList: configurationListReducer,
    associateAssets: associateAssetsReducer,
    assetTypes: assetTypesReducer,
    createConfiguration: createConfigurationReducer,
    assetsByAssetType: assetListByAssetTypeReducer,
    disassociateAssets: disassociateAssetsReducer,
    configurationsForStatus: configurationsForStatusReducer,
    configurationDetails: configurationDetailsReducer,
    templateDetails: templateDetailsReducer,
    configurationDetailsForStatus: configurationDetailsForStatusReducer,
    templateIdForConfigurationDetails: templateIdReducer,
    assignedAssetList: assignedAssetListReducer,
    thirtyDay: thirtyDayReducer,
    grandParentBreadcrumb: grandParentBreadcrumbReducer,
    allConfigData: allConfigDataReducer,
    allStatusFiles: allStatusFilesReducer,
    createDatapubConfig: createReducer,
    operationPermissions: operationPermissionsReducer,
    kpiType: kpiTypeReducer,
    hamburgerState: hamburgerStateReducer,
    ipConfigState: ipConfigReducer
  },
  middleware: [thunk, logger]
})

export default store
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
